import { swSettings } from "app/common/services/swSettings";
import { createActivationApi } from "app/pages/activation/services/api";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { EPrimarySideBar3StateType } from "app/reducers/_reducers/PrimarySidebar3Reducer";

import { ACTIVATION_PROJECT_ROUTE, ACTIVATION_HOME_ROUTE, DEFAULT_ACTIVATION_GRANULARITY } from "../constants";

// This route handler required to route users on Activation if they have access

export const routeToActivation = async () => {
    const api = createActivationApi();

    const hasActivation =
        swSettings.components?.Activation?.isAllowed && !swSettings.components?.Activation?.isDisabled;

    if (hasActivation) {
        const webSource: unknown = swSettings.components?.Activation?.resources?.DefaultSource;

        const activationSets = await api.activation.getShortActivations();

        const defaultActivationSet = activationSets?.find((set) => set.isFavorite);

        if (defaultActivationSet) {
            const params = {
                key: defaultActivationSet?.id,
                country: defaultActivationSet?.country,
                timeGranularity: DEFAULT_ACTIVATION_GRANULARITY,
                webSource,
            };

            return proNavigator.go(ACTIVATION_PROJECT_ROUTE, params, {
                location: "replace",
            });
        }

        return proNavigator.go(ACTIVATION_HOME_ROUTE, {}, { location: "replace" });
    } else {
        proNavigator.go(EPrimarySideBar3StateType.Home);
    }
};
